import { gql, TypedDocumentNode } from '@apollo/client'
import { userFragment } from '@vivaldis/graphql'
import type { UserQuery, UserQueryVariables } from './__generated__/UserQuery'

export const userQuery: TypedDocumentNode<UserQuery, UserQueryVariables> = gql`
  ${userFragment}

  query UserQuery($locale: String) {
    user {
      ...UserFragment
    }
  }
`
